import React, { ReactNode, useState } from 'react';
import './card.css';

type Props = {
  onClick?: () => void;
  linkText?: string;
  children: ReactNode;
  outerCss?: string;
  innerCss?: string;
  asCard?: boolean;
};
function ClickableCard({ children, linkText, onClick, outerCss, innerCss, asCard = true }: Props) {
  const [hovering, setHovering] = useState<boolean>(false);

  return (
    <div
      onClick={onClick}
      role={onClick !== undefined ? 'button' : 'none'}
      className={`block relative ${outerCss || ''}`}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
    >
      <div
        className={`relative transition-all ${asCard ? 'pt-3 px-4 pb-4 rounded-2 bg-white' : ''} ${
          onClick ? 'cursor-pointer' : ''
        } ${onClick && hovering ? 'bg-brand-lightest' : ''} ${innerCss || ''}`}
      >
        {children}
      </div>
      {onClick && (
        <div
          className={`absolute cursor-pointer rounded-bl-2 rounded-br-2 left-0 right-0 top-full text-brand font-bold text-xs bg-brand-lightest transition-all ${
            hovering ? 'h-4 shadow-sm' : 'h-0'
          }`}
        >
          <span
            className={`absolute block bottom-0 left-0 px-4 pb-2 transition-opacity cursor-pointer ${
              hovering ? 'visible opacity-1' : 'hidden opacity-0'
            }`}
          >
            {linkText || 'Clickable'}
          </span>
        </div>
      )}
    </div>
  );
}

export { ClickableCard };
